import { memo, ReactNode } from 'react';
import { useTranslations } from '../../hooks';
import PromptDialog, { IPromptDialogProps } from '../PromptDialog';
import PromptList, { IPromptListProps } from '../PromptDialog/components/PromptList';
import Box from '../Box';
import Typography from '../Typography';

export interface IPromptModalProps extends IPromptDialogProps, Partial<IPromptListProps> {
  description: string | ReactNode;
  additionalDescription?: string;
}

const PromptModal = (props: IPromptModalProps) => {
  const {
    open,
    onClose,
    onSubmit,
    title,
    description,
    additionalDescription,
    list,
    renderField,
    renderKey,
    isLoading,
    approvalButtonText = 'common.remove',
    rejectionButtonText = 'common.cancel',
    approvalButtonColor,
    disableCustomScrollbar = false,
  } = props;
  const { t } = useTranslations();

  return (
    <PromptDialog
      onSubmit={onSubmit}
      open={open}
      isLoading={isLoading}
      onClose={onClose}
      title={title}
      approvalButtonText={t(approvalButtonText)}
      rejectionButtonText={t(rejectionButtonText)}
      approvalButtonColor={approvalButtonColor}
      disableCustomScrollbar={disableCustomScrollbar}
    >
      <Typography>
        {description}
      </Typography>
      {Array.isArray(list) && renderField && renderKey && (
        <>
          <Box mt={2} />
          <PromptList
            list={list}
            renderField={renderField}
            renderKey={renderKey}
            disableCustomScrollbar={disableCustomScrollbar}
          />
        </>
      )}
      {additionalDescription && (
        <Typography mt={2}>
          {additionalDescription}
        </Typography>
      )}
    </PromptDialog>
  );
};

export default memo(PromptModal);
